import { defineComponent } from 'vue';
import BaseModal from '@/components/Shared/Modals/BaseModal/BaseModalComponent';

export default defineComponent({
  components: {
    BaseModal,
  },
  data() {
    return {};
  },
  methods: {
    toggleModal(status: boolean) {
      const el: any = this.$refs['base-modal'];
      el.toggleBaseModal(status);
    },
    goBack() {
      this.toggleModal(false);
    },
    goAhead() {
      this.$emit('nextStep');
      this.toggleModal(false);
    },
  },
});
